import { z } from 'zod';

export const bookingTypeSchema = z.string();

export const knownBookingTypes = {
    ORDER_COM_RIO_FMS: 'ORDER_COM_RIO_FMS',
    POCKET_DRIVER_VEHICLE: 'POCKET_DRIVER_VEHICLE',
    POCKET_DRIVER_USER: 'POCKET_DRIVER_USER',
} as const;

export const scopedBookingsSchema = z.object({
    assetBookings: z.array(bookingTypeSchema),
    accountBookings: z.array(bookingTypeSchema),
});

export type BookingType = z.infer<typeof bookingTypeSchema>;
export type ScopedBookings = z.infer<typeof scopedBookingsSchema>;
